import React, { useMemo } from 'react';
import {
  ListElemText,
  parseNumberByPrecision,
  RoundStatus,
  DotsLoader,
  userInfoStore,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { parseOddByPrecision } from '../../../helpers';
import { TranslationKeys } from '../../../enums/translationKeys';

export const StatusMapper = observer(({ status, roundData, t }) => {
  const { precision } = userInfoStore;

  const oddsRepresentation = useMemo(() => {
    if (roundData) {
      const totalOdd = +roundData?.[0].odd
        ? roundData
            ?.filter((item) => item.odd)
            .reduce((acm, current) => parseNumberByPrecision(acm, current.odd, precision, true), 1)
        : 0;
      return parseOddByPrecision(totalOdd, precision);
    }
    return '';
  }, [roundData]);

  if (status === RoundStatus.Upcoming) {
    return (
      <ListElemText className='inner-lists-item-row-item-txt t-t-n' noTextTransform>
        {t(TranslationKeys.SOON)}
      </ListElemText>
    );
  }
  if (status !== RoundStatus.Finished && status !== RoundStatus.OnFinish) {
    return (
      <ListElemText forSaving>
        <DotsLoader />
      </ListElemText>
    );
  }

  return <ListElemText style={{ textTransform: 'lowercase' }}> x{oddsRepresentation}</ListElemText>;
});
